export function getApiUrl(): string {
  return import.meta.env.VITE_API_URL ?? 'http://localhost:8787/v1';
}

export function getWebUrl(): string {
  return import.meta.env.VITE_WEB_URL ?? 'http://localhost:3000';
}

export function buildWebLoginUrl(returnUrl?: string): string {
  const url = new URL('/login', getWebUrl());
  if (returnUrl) {
    url.searchParams.set('returnUrl', returnUrl);
  }
  return url.toString();
}
